import { UsersApi } from './types';

const base = '/users';
const autocomplete = `${base}/autocomplete`;
const compartidos = `${base}/compartidos`;
const directory = `${base}/directorio/`;
const workplace = `${base}/tu-arsat/lugar-trabajo`;

export const usersApi: Readonly<UsersApi> = {
  autocompleteBoss: (filters) => `${autocomplete}/boss${filters}}`,
  autocompleteHijos: (filters) => `${base}/hijos${filters}`,
  autocompleteCompartir: (filters) => `${autocomplete}/compartir${filters}`,
  autocompleteSubgerencias: (filters) =>
    `${autocomplete}/subgerencias${filters}`,
  autocompleteUser: (filters) => `${autocomplete}/name-file-number${filters}`,
  birthday: (filters) => `${base}/birthday/${filters}`,
  compartidosBase: (filters) => `${compartidos}/${filters}`,
  compartidosPorId: (id, filters) => `${compartidos}/${id}/${filters}`,
  compartidosPorIdPermiso: (id, filters) =>
    `${compartidos}/${id}/permiso/${filters}`,
  compartidosViaticos: (filters) => `${compartidos}/viaticos/${filters}`,
  compartidosViaticosQuitarPermisos: (id, filters) =>
    `${compartidos}/viaticos/${id}/${filters}`,
  directorioBase: (filters) => `${directory}${filters}`,
  directorioFavorito: (filters) => `${directory}favorito/${filters}`,
  directorioGerencias: (filters) => `${directory}gerencias/${filters}`,
  directorioIndice: (filters) => `${directory}indice/${filters}`,
  profileImage: (filters) => `${base}/archivos/foto/${filters}`,
  tareasPendientes: () => `${base}/current/tareas-pendientes`,
  topes: (filters) => `${base}/jefe/topes/${filters}`,
  tuArsat: (filters) => `${base}/tu-arsat/${filters}`,
  tuArsatContacto: (filters) => `${base}/tu-arsat/contacto/${filters}`,
  userCurrent: (filters) => `${base}/current/${filters}`,
  workplaceBase: (filters) => `${workplace}/${filters}`,
  workplaceOption1: (filters) => `${workplace}/opcion1/${filters}`,
  workplaceOption2: (filters) => `${workplace}/opcion2/${filters}`,
  workplaceOption3: (filters) => `${workplace}/opcion3/${filters}`,
  compartidoPresentismo: () =>
    `${base}/compartidos/presentismo/irregularidades/`,
  eliminarCompartidoPresentismo: (id, filters) =>
    `${base}/compartidos/presentismo/irregularidades/${id}${filters}`,
  getQrUrl: () => `${base}/qr-url`,
  getQrVcard: (id_user) => `${base}/qr-vcard/${id_user}`,
};
